import { useEffect, useState } from "react";

export const pad = (n) => String(n).padStart(2, "0");

export function useCountdown(end) {
  const [left, setLeft] = useState(() => (end ? new Date(end) - Date.now() : 0));
  useEffect(() => {
    if (!end) return undefined;
    const t = setInterval(() => setLeft(new Date(end) - Date.now()), 1000);
    return () => clearInterval(t);
  }, [end]);
  const s = Math.max(0, Math.floor(left / 1000));
  return { left, d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
}

export const fmtEnd = (iso) => new Date(iso).toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: "Europe/Berlin" });
